<div class="min-h-screen pt-6 pb-32 px-5">
  <ng-container *ngIf="check?.[checkKeys.Id]">
    <ng-container *ngIf="check?.[checkKeys.OutstandingAmount] <= 0">
      <div class="flex justify-center pb-3 md:w-8/12">
        <p
          class="text-accent text-2xl md:text-5xl font-bold text-neutral-800 mr-6 md:mr-7 leading-8"
        >
          {{ 'pay-at-table.overview.bill-payed' | translate }}
        </p>
        <span><i class="icon icon-n-check text-success-600 text-4xl md:text-5.8xl"></i></span>
      </div>
      <div class="pb-3 md:w-8/12">
        <div class="flex flex-col p-5 md:p-6 mb-3 md:mb-8 rounded-m bg-neutral-100 text-center">
          <p class="text-md md:text-29px font-accent font-bold text-neutral-800">
            {{ 'pay-at-table.overview.thanks-for-visit' | translate }}
          </p>
        </div>
      </div>
    </ng-container>
  </ng-container>
  <h1
    *ngIf="check?.[checkKeys.OutstandingAmount] > 0"
    class="mb-1 font-accent font-bold text-2xl lg:text-3xl text-neutral-800"
  >
    {{ 'pay-at-table.overview.title' | translate }}
  </h1>
  <ng-container *ngIf="check?.[checkKeys.Shop] as shop">
    <p
      *ngIf="shop?.name; else loadingTemplate"
      class="mb-6 font-base text-sm text-neutral-600"
    >
      <span> {{ shop.name }}</span>
      <span *ngIf="check?.[checkKeys.OnSiteLocation] as onsite"> — {{ onsite.name }}</span>
    </p>
    <ng-template #loadingTemplate>
      <p class="animate-pulse h-6 bg-neutral-200 rounded w-9/12 mb-3"></p>
    </ng-template>
  </ng-container>

  <ng-container *ngIf="check?.[checkKeys.Items] as items">
    <ng-container *ngIf="items?.length; else loadingTemplateItems">
      <div
        *ngFor="let item of items"
        class="flex items-center py-3 border-b border-neutral-300"
      >
        <div class="mr-2">
          <app-quantity-atom [quantity]="1"></app-quantity-atom>
        </div>
        <div class="flex justify-between items-center w-full">
          <p>
            <span class="inline-block ml-2 text-base lg:text-md font-bold font-base leading-6">{{
              item.name
            }}</span>
          </p>
          <app-price-atom
            [amount]="item.price"
            [format]="true"
            [bold]="false"
          ></app-price-atom>
        </div>
      </div>
    </ng-container>
    <ng-template #loadingTemplateItems>
      <div
        *ngFor="let i of [].constructor(5)"
        class="flex justify-between items-center py-3 border-b border-neutral-300 w-full"
      >
        <div class="w-9/12 flex">
          <p class="h-6 rounded-2xl animate-pulse bg-neutral-400 w-6"></p>
          <p class="h-6 ml-2 animate-pulse bg-neutral-200 w-7/12"></p>
        </div>
        <div class="h-6 animate-pulse bg-neutral-200 w-10"></div>
      </div>
    </ng-template>
  </ng-container>
  <ng-container>
    <div
      *ngIf="check?.[checkKeys.Id]; else loadingTemplateAmount"
      class="flex justify-between pt-3 pb-5"
    >
      <span class="font-accent font-bold text-md leading-6">{{
        'pay-at-table.overview.total' | translate
      }}</span>
      <span class="font-accent font-bold text-base leading-6"
        ><app-price-atom [amount]="check[checkKeys.FinalPrice] / 100"></app-price-atom
      ></span>
    </div>

    <ng-template #loadingTemplateAmount>
      <div class="flex justify-between mt-3">
        <p class="animate-pulse h-5 bg-neutral-400 rounded w-6/12 mb-3"></p>
        <p class="animate-pulse h-5 bg-neutral-400 rounded w-2/12 mb-3"></p>
      </div>
    </ng-template>
  </ng-container>

  <ng-container *ngIf="capturedTransactons as transactions">
    <div
      *ngFor="let transaction of transactions"
      class="font-accent leading-6 py-2 border-b border-neutral-300"
    >
      <div class="flex justify-between">
        <p class="font-bold">
          {{ 'pay-at-table.overview.payment' | translate }}
        </p>
        <p class="pl-2">
          -
          <app-price-atom
            *ngIf="!transaction?.tip?.amount"
            [format]="true"
            [amount]="transaction.paid_amount"
            [bold]="false"
          ></app-price-atom>
          <app-price-atom
            *ngIf="transaction?.tip?.amount"
            [format]="true"
            [amount]="transaction.paid_amount - transaction?.tip?.amount"
            [bold]="false"
          ></app-price-atom>
        </p>
      </div>
      <div
        *ngIf="transaction?.tip"
        class="flex justify-between text-neutral-600"
      >
        <p class="flex">
          <i class="flex items-center icon icon-satisfied mr-2"></i
          >{{ 'pay-at-table.overview.tip' | translate }}
        </p>
        <p class="pl-2">
          <app-price-atom
            [format]="true"
            [amount]="transaction?.tip?.amount"
            [bold]="false"
          ></app-price-atom>
        </p>
      </div>
    </div>
  </ng-container>

  <ng-container>
    <div
      *ngIf="check?.[checkKeys.Id]; else loadingRemainAmount"
      class="flex justify-between py-3"
    >
      <span class="font-accent font-bold text-md leading-6">{{
        'pay-at-table.overview.left-to-pay' | translate
      }}</span>
      <span class="font-accent font-bold text-base leading-6"
        ><app-price-atom [amount]="check[checkKeys.OutstandingAmount] / 100"></app-price-atom
      ></span>
    </div>

    <ng-template #loadingRemainAmount>
      <div class="flex justify-between">
        <p class="animate-pulse h-5 bg-neutral-400 rounded w-6/12 mb-3"></p>
        <p class="animate-pulse h-5 bg-neutral-400 rounded w-2/12 mb-3"></p>
      </div>
    </ng-template>
  </ng-container>
</div>
